module.exports = __webpack_public_path__ + "img/logo.7a6e2ca2.png";